<template>

  <el-dialog
    title=" "
    :fullscreen="true"
    :visible.sync="show"
    :show-close="false"
    :before-close="() => {}">
    <template>
      <div :style="{height: window.innerHeight + 'px', background: '#000'}" @click="$emit('close')">

        <mt-swipe :auto="0" :show-indicators="false" :speed="100" :defaultIndex="defaultIndex" ref="swipe">
          <mt-swipe-item v-for="(item, index) in newImgs" :key="index">
            <div class="flex-center-center" style="height:100%;background: #000">
              <el-image style="width: 100%;height:100%"
                        :src="item"
                        fit="contain"></el-image>
            </div>
          </mt-swipe-item>
        </mt-swipe>
      </div>
    </template>
  </el-dialog>

</template>

<script>
    export default {
      name: 'previewImg',
      props: {
        images: {
          type: Array,
          default: []
        },
        actImg: {
          type: String,
          default: null
        }
      },
      data () {
        return {
          defaultIndex: 0
        }
      },
      watch: {
        show (n) {
          if (n) {
            this.changeSwipe(this.actIndex)
          }
        }
      },
      methods: {
        changeSwipe(index) {
          setTimeout(() => {
            this.defaultIndex = index
            this.$refs.swipe.swipeItemCreated()
          })
        }
      },
      computed: {
        window () {
          return window
        },
        show () {
          return !!this.actImg
        },
        actIndex () {
          return this.images.indexOf(this.actImg)
        },
        newImgs () {
          return this.images && this.images.length ? this.images : [this.actImg]
        }
      }
    }
</script>

<style scoped>
  * /deep/ .el-dialog__header {display: none}
  * /deep/ .el-dialog__body {
    padding: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/video/previewImg.vue